<template>
  <section id="contact">
    <div class="position-relative py-5">
      <div class="background-image-section">
        <div class="container-fluid">
          <img src="@/assets/img/contact-element-1.svg" class="img-fluid" width="700px" :title="title" :alt="title">
        </div>
      </div>
      <div class="container position-relative py-lg-5">
        <div class="row justify-content-between align-items-center">
          <div class="col-md-6 pe-md-5">
            <h3 class="h1 font-gradient mb-4 mb-lg-5">{{ title }}</h3>
            <p class="mb-4 mb-lg-5">{{ text }}</p>
            <a class="btn btn-primary" :href="linkedin" target="_blank">
              You can check me out on Linkedin <i class="lab la-linkedin"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped>
  .background-image-section {
    display: flex;
    align-items: center;
  }
</style>
<script>
export default {
  name: 'ContactComponent',
  data () {
    return {
      title: 'Get in Touch',
      text: '"Have a project in mind or just want to connect? Feel free to reach out! I’m always excited to collaborate, discuss ideas, or answer questions. Let’s make something great together!',
      linkedin: 'https://www.linkedin.com/in/martin-matovski-21b965150/',
    }
  },
  components: {
  },
  methods: {
  }
}
</script>